import styled from 'styled-components';

export const SPreviewFileModalContent = styled.div`
  height: calc(100vh - 300px);
`;
